import { render, staticRenderFns } from "./turnDoctor.vue?vue&type=template&id=f6d89d12&"
import script from "./turnDoctor.vue?vue&type=script&lang=js&"
export * from "./turnDoctor.vue?vue&type=script&lang=js&"
import style0 from "./turnDoctor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports